import { render } from "./CarousalCompTypeThree.vue?vue&type=template&id=15446136"
import script from "./CarousalCompTypeThree.vue?vue&type=script&lang=js"
export * from "./CarousalCompTypeThree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__